import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { SuccessMessage } from 'network/messageTranslationHelpers/messages'

/**
 * Service to get Holdem game tables only
 */
export const getHoldemGameTablesService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, 'poker/get-all-game-tables', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

/**
 * Service to take seat in Holdem game
 * @param {object} data - object contains { tableId, seatNumber, buyInAmount, gameType: 'holdem' }
 */
export const takeHoldemSeatService = (data) => {
  const holdemData = {
    ...data,
    gameType: 'holdem'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-seat', holdemData, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to take Holdem game action (call, bet, raise, check, fold)
 * @param {object} data - object contains { tableId, roundId, action, betAmount?, gameType: 'holdem' }
 */
export const takeHoldemActionService = (data) => {
  const holdemData = {
    ...data,
    gameType: 'holdem'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-action', holdemData, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Holdem player sitting status (direct sit-out/return)
 * @param {object} data - object contains { tableId, sittingOut, sitOutType?, gameType: 'holdem' }
 */
export const updateHoldemPlayerSittingStatusService = (data) => {
  const payload = {
    tableId: data.tableId,
    sittingOut: data.sittingOut,
    gameType: 'holdem'
  }

  // Only include sitOutType when sitting out (sittingOut: true)
  // When returning (sittingOut: false), backend will set sitOutType to null

  if (data.sittingOut && data.sitOutType) {
    payload.sitOutType = data.sitOutType
  }
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sitting-status', payload, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.sittingStatusUpdatedSuccessfully,
    handlerEnabled: true
  })
}

/**
 * Service to update Holdem player "Sit Out Next BB" flag
 * @param {object} data - object contains { tableId, sitOutNextBB, gameType: 'holdem' }
 */
export const updateHoldemPlayerSitOutNextBBService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sit-out-next-bb', {
    tableId: data.tableId,
    sitOutNextBB: data.sitOutNextBB,
    gameType: 'holdem'
  }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Holdem buy-in amount
 * @param {object} data - object contains { tableId, newAmount, gameType: 'holdem' }
 */
export const updateHoldemBuyInAmountService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-buyIn-amount', { ...data }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to change seat in Holdem game
 * @param {object} data - object contains { tableId, fromSeat, toSeat, gameType: 'holdem' }
 */
export const changeHoldemSeatService = (data) => {
  return axiosInstanceService(METHOD_TYPES.put, 'poker/change-seat', { ...data, gameType: 'holdem' }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to submit run it twice decision
 * @param {object} data - object contains { tableId, roundId, decision: 'ACCEPTED' | 'DECLINED' }
 */
export const runItTwiceDecisionService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/run-it-twice/decision', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
